import {ActionList} from '@primer/react'
import {useCallback} from 'react'
import {TrashIcon} from '@primer/octicons-react'
import {ListItem} from '@github-ui/list-view'
// eslint-disable-next-line no-restricted-imports
import {useToastContext} from '@github-ui/toast/ToastContext'
import {commitRemoveSubIssueMutation} from './mutations/remove-sub-issue-mutation'
import {useRelayEnvironment} from 'react-relay'

export function SubIssuesActionBar({issueId, subIssueId}: {issueId: string; subIssueId: string}) {
  const environment = useRelayEnvironment()

  const {addToast} = useToastContext()

  const removeSubIssue = useCallback(() => {
    commitRemoveSubIssueMutation({
      environment,
      input: {
        issueId,
        subIssueId,
      },
      onError: error => {
        // eslint-disable-next-line @github-ui/dotcom-primer/toast-migration
        addToast({
          type: 'error',
          message: error.message,
        })
      },
    })
  }, [environment, issueId, subIssueId, addToast])

  return (
    <ListItem.ActionBar
      staticMenuActions={[
        {
          key: 'remove',
          render: () => (
            <ActionList.Item
              role="menuitem"
              as="button"
              variant="danger"
              aria-label="Remove sub-issue"
              onClick={removeSubIssue}
            >
              <ActionList.LeadingVisual>
                <TrashIcon />
              </ActionList.LeadingVisual>
              Remove sub-issue
            </ActionList.Item>
          ),
        },
      ]}
    />
  )
}

try{ SubIssuesActionBar.displayName ||= 'SubIssuesActionBar' } catch {}